module.exports = __webpack_public_path__ + "static/media/odometer.b4ba43d7.svg";